var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-open-card',{attrs:{"question":_vm.question,"question-name":(_vm.questionType + " משתנה"),"buttons":_vm.buttons}})}
var staticRenderFns = []

export { render, staticRenderFns }